module.exports = __webpack_public_path__ + "static/img/vertex-error.52a08687.png";